import {useNavigate, useSearchParams} from "react-router-dom";

interface PaginationProps {
    totalCount: number;
    limit?: number;
    disabled?: boolean;
    onClickCallback?: () => void;
    onDisabledCallback?: () => void;
}

/**
 * URL query string 사용하는 Pagination
 * 메인 페이지 리스트의 Pagination에만 사용
 */
export function PaginationMain({
                                   totalCount,
                                   limit = 10,
                                   disabled,
                                   onClickCallback,
                                   onDisabledCallback,
                               }: PaginationProps) {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get("pageNo")) || 1;
    const totalPage = totalCount !== 0 ? Math.ceil(totalCount / limit) : 1;

    const buildQuery = (pageNo: number) => {
        const params = new URLSearchParams(searchParams);
        const validPage = Math.max(1, Math.min(totalPage, pageNo));
        params.set("pageNo", validPage.toString());
        return `?${params.toString()}`;
    };

    const buildPage = (pageNo: number) => {
        const pageElement = [];

        const pageDisplayCount = 9;
        const half = Math.floor(pageDisplayCount / 2);

        let startPage = pageNo - half;
        let endPage = pageNo + half;

        // 1보다 작으면 앞쪽 보정
        if (startPage < 1) {
            endPage += (1 - startPage);
            startPage = 1;
        }

        // 마지막 페이지보다 크면 뒤쪽 보정
        if (endPage > totalPage) {
            startPage -= (endPage - totalPage);
            endPage = totalPage;
        }

        // 다시 1보다 작을 수 있으므로 보정
        if (startPage < 1) startPage = 1;

        for (let i = startPage; i <= endPage; i++) {
            if (i === pageNo) {
                pageElement.push(<li key={i} className="active">{i}</li>);
            } else {
                pageElement.push(
                    <li key={i} className="" onClick={() => navigate(buildQuery(i))}>
                        {i}
                    </li>
                );
            }
        }

        return pageElement;
    };

    const btnCallback = (number: number) => {
        if (!disabled) {
            onClickCallback && onClickCallback()
            navigate(buildQuery(number));
        } else {
            onDisabledCallback && onDisabledCallback();
        }
    };

    return (
        <div className="pagination-container">
            <ul>
                <li className="pg_nav" onClick={() => btnCallback(1)}>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                        alt="First Page"
                    />
                </li>
                <li className="pg_nav" onClick={() => btnCallback(page - 1)}>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                        alt="Previous Page"
                    />
                </li>
                {buildPage(page)}
                <li className="pg_nav" onClick={() => btnCallback(page + 1)}>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                        alt="Next Page"
                    />
                </li>
                <li className="pg_nav" onClick={() => btnCallback(totalPage)}>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                        alt="Last Page"
                    />
                </li>
            </ul>
        </div>
    );
}
